var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"width":"100%","height":"84vh","border":"0","padding-top":"10px"},attrs:{"src":_vm.workflowUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }